module.exports = __webpack_public_path__ + "img/category01.b5f8b568.png";